import React from 'react';
import ReactDOM from 'react-dom';
import { Box, IconButton, Stack } from '@mui/material';

import { ContentLayout } from './ContentLayout';
import { IconWrapper } from 'components/Icon';
import { useNavbar } from 'lib/navbarContext';

import { VERTICAL_NAV } from '../config';

// Reuses the real ContentLayout (same header/search, same fixed-width
// centered content, same grey page background) so a full-page "step" looks
// identical to every other page, instead of approximating the layout.
export const FullPageStep = ({ onClose, children }) => {
  const { closeMenu } = useNavbar();

  const content = (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        height: '100vh',
        zIndex: (theme) => theme.zIndex.modal,
        overflowY: 'auto',
        width: {
          xs: `calc(100vw - ${VERTICAL_NAV.closedWidth})`,
          lg: `calc(100vw - ${closeMenu ? VERTICAL_NAV.closedWidth : VERTICAL_NAV.width})`,
        },
        left: {
          xs: VERTICAL_NAV.closedWidth,
          lg: `${closeMenu ? VERTICAL_NAV.closedWidth : VERTICAL_NAV.width}`,
        },
      }}
    >
      <ContentLayout parentSx={{ minHeight: '100vh' }}>
        <Stack direction="row" justifyContent="flex-end" pb={3}>
          <IconButton onClick={onClose}>
            <IconWrapper icon="xMark" sx={{ svg: { mt: -1 } }} />
          </IconButton>
        </Stack>
        {children}
      </ContentLayout>
    </Box>
  );

  return ReactDOM.createPortal(content, document.body);
};
